import { format, parse, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function formattedDatePtBr(value: string) {
  if (!value) return ''

  try {
    const date = parseISO(value)

    if (isNaN(date.getTime())) return ''

    return format(date, 'dd/MM/yyyy', { locale: ptBR })
  } catch {
    return ''
  }
}

/**
 * Formata data para exibição (dd/MM/yyyy) usando apenas a parte da data (yyyy-MM-dd),
 * sem aplicar fuso horário. Evita que valores ISO com "Z" (ex.: 2025-12-01T00:00:00.000Z)
 * apareçam como o dia anterior no fuso local.
 * Uso recomendado para "data prevista de admissão" e outros campos só de data.
 */
export function formattedDatePtBrDateOnly(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return ''

  const str = String(value).trim()
  const datePart = str.match(/^\d{4}-\d{2}-\d{2}/)?.[0]
  if (datePart) {
    try {
      const date = parse(datePart, 'yyyy-MM-dd', new Date())
      if (!isNaN(date.getTime())) {
        return format(date, 'dd/MM/yyyy', { locale: ptBR })
      }
    } catch {
      // fallback
    }
  }
  return formattedDatePtBr(str)
}
